import type { AddressForBookingOutputRecord } from '@navio/nsdk';
import { useAddressResolution } from './useAddressResolution';

type UseAddressMapNavigationOptions = {
  brandDomains?: string[];
  onAddressResolved?: (address: AddressForBookingOutputRecord) => void;
};

export const useAddressMapNavigation = (options?: UseAddressMapNavigationOptions) => {
  const {
    resolve: createAddressFromPlaceId,
    clear: reset,
    isPending,
    data: addressResponse,
    error,
    recoveryFormProps
  } = useAddressResolution({
    onSuccess: (address) => options?.onAddressResolved?.(address)
  });

  const address = addressResponse?.data;

  const handleSelect = (suggestion: { placeId: string }) => {
    createAddressFromPlaceId({
      placeId: suggestion.placeId,
      brandDomains: options?.brandDomains
    });
  };

  const handleClear = () => {
    reset();
  };

  return { recoveryFormProps, address, isPending, error, handleSelect, handleClear };
};
